import AdministrationProjectStages from './AdministrationProjectStages'

export default AdministrationProjectStages
